package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun IceStormMetadata() {
    SpellMetadata(
        spellIndex = "ice-storm",
        castingTime = "1 action",
        range = "300 feet",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC, SpellComponent.MATERIAL),
        material = "A pinch of dust and a few drops of water.",
        duration = "Instantaneous",
        damageBase = "Bludgeoning 2d8 + 4d6",
        damageScaling = mapOf("4" to "2d8 + 4d6", "5" to "3d8 + 4d6", "6" to "4d8 + 4d6", "7" to "5d8 + 4d6", "8" to "6d8 + 4d6", "9" to "7d8 + 4d6"),
        savingThrow = "DEX (Half)",
        aoe = "20-ft Cylinder",
        concentration = false
    )
}
